/* eslint-disable prettier/prettier */
import settings from 'settings';
// eslint-disable-next-line no-unused-vars
import axios from 'axios';
import appDebug from './json/app.json';
import contactFormDebug from './json/contact-form.json';

import productsDebug from './json/products.json';
import areasDebug from './json/areas.json';

export default class Requests {
  static getDebugMode() {
    return settings.debugMode();
    // https://stage.axelent.sv.cimplex.se/api/xperience/app?culture=sv-SE
  }

  static getCulture() {
    let culture = document.querySelector('html').lang;
    if (culture === '[culture]') {
      culture = 'sv-SE';
    }
    return culture;
  }

  static getXperiencePageId() {
    let pageId = document.querySelector('meta[name="XperiencePage"]').content;
    // For debug ? probably...
    if (pageId === '[xperiencePage]') {
      pageId = 151996;
    }
    return pageId;
  }

  static getUmracoContactForm(formId, setContactFormData) {
    const useDebug = this.getDebugMode();

    const apiKey = settings.ufApiKey();
    let url = `${
      window.location.origin
    }/umbraco/forms/api/v1/definitions/${formId}?culture=${this.getCulture()}`;
    const options = { headers: { 'Api-Key': apiKey } };

    if (useDebug) {
      url = contactFormDebug;
    }

    axios
      .get(url, options)
      .then((response) => {
        // handle success
        console.log(response);
        setContactFormData(response.data);
      })
      .catch((error) => {
        // handle error
        console.log(error);
      })
      .finally(() => {
        // always executed
      });
    // https://stage.axelent.en.cimplex.se/umbraco/forms/api/v1/definitions/f09936a2-1ca7-432a-94ad-0d4afaf95e45?culture=sv-SE'
    // Api-Key: 9a8a3c1d-1e5e-45d2-b95c-8bd023568e79'
  }

  static postToUmbracoContactForm(formId, formData, callback) {
    const apiKey = settings.ufApiKey();
    const url = `${window.location.origin}/umbraco/forms/api/v1/entries/${formId}`;

    const options = {
      headers: { 'Api-Key': apiKey, 'Content-Type': 'application/json' },
    };
    const data = {
      values: formData.values,
      contentId: String(Requests.getXperiencePageId()),
      culture: this.getCulture(),
    };
    console.log('POST -> ', data);
    axios
      .post(url, data, options)
      .then((response) => {
        // handle success
        console.log(JSON.stringify(response.data));
        callback('success');
      })
      .catch((error) => {
        // handle error
        console.log(error);
        callback('error');
      })
      .finally(() => {
        // always executed
      });
    /*
        curl --location --request POST 'https://stage.axelent.en.cimplex.se/umbraco/forms/api/v1/entries/f09936a2-1ca7-432a-94ad-0d4afaf95e45' \
    --header 'Api-Key: 9a8a3c1d-1e5e-45d2-b95c-8bd023568e79' \
    --header 'Content-Type: application/json' \
    --data-raw '{
        "values": {
            "company": "Cimplex AB",
            "firstname": "Herman",
            "lastname": "Emanuelsson",
            "email": info@cimplex.se,
            "privacyPolicy": "true",
            "personalInformation": "true"
        },
        "contentId": "152717",
        "culture": "sv-SE"
    }'
    */
  }

  static getProductDataById(productId, productType, callback, appData) {
    // Get numericalProduct Id
    let pid = -1;
    const { products } = appData;
    const { areas } = appData;

    const data = products.concat(areas);
    data.forEach((entry) => {
      if (entry.alias === productId) {
        if (entry.productPostId) {
          pid = entry.productPostId;
        }

        if (entry.areaPostId) {
          pid = entry.areaPostId;
        }
      }
    });

    if (pid === -1) {
      return;
    }

    const useDebug = this.getDebugMode();
    const ref = window.location.href;
    let url = '';
    if (!useDebug) {
      if (productType === 0) {
        url = `${window.location.origin}/api/xperience/app/products/${pid}`;
      } else {
        url = `${window.location.origin}/api/xperience/app/areas/${pid}`;
      }
    }

    if (useDebug) {
      if (productType === 0) {
        url = productsDebug;
      } else {
        url = areasDebug;
      }
    }
    // console.log('url: ', url);
    // console.log('productType: ', productType);

    return fetch(url, {
      headers: {
        /* prettier-ignore */
        'XperiencePage': this.getXperiencePageId(),
        /* prettier-ignore */
        'Referer': ref,
      },
    })
      .then((response) => response.json())
      .then((json) => {
        if (useDebug) {
          const item = this.getStaticItemJSON(pid, json);
          callback(item);
        } else {
          callback(json);
        }
      });
  }

  static getStaticItemJSON(pid, items) {
    // console.log('pid: ', pid);
    // console.log('items: ', items);
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      if (item.id === pid) {
        return item;
      }
    }
  }

  static getAppData() {
    this.getCulture();
    const useDebug = this.getDebugMode();

    // eslint-disable-next-line no-unused-vars
    const ref = window.location.href;
    // eslint-disable-next-line prefer-const
    let url = `${window.location.origin}/api/xperience/app`;
    // url = 'https://www.axelent.com/api/xperience/app';
    // console.log('origin --> ', window.location.origin);

    if (useDebug) {
      url = appDebug;
    }

    return fetch(url, {
      headers: {
        /* prettier-ignore */
        'XperiencePage': this.getXperiencePageId(),
        /* prettier-ignore */
        // 'Referer': ref,
        'referer': window.location.origin,
      },
    })
      .then((response) => response.json())
      .then((json) => {
        console.log('response ->', json);
        return json;
      });
  }
}
